import type { WebappMission } from '@/types/types'
import type { BrandAppNews, BrandAppOfferCard } from '../lib/brandAppContract'

export type ContentKind = 'offer' | 'actu' | 'mission'

export type ContentPreviewView = 'card' | 'detail'

export type ContentDraft =
  | { kind: 'offer'; item: BrandAppOfferCard }
  | { kind: 'actu'; item: BrandAppNews }
  | { kind: 'mission'; key: string; item: WebappMission }

const editing = ref<{ kind: ContentKind; isNew: boolean } | null>(null)
const draft = shallowRef<ContentDraft | null>(null)
const view = ref<ContentPreviewView>('detail')

export default function useContentEditing() {
  const startEditing = (kind: ContentKind, isNew: boolean) => {
    editing.value = { kind, isNew }
    draft.value = null
    view.value = 'detail'
  }

  const stopEditing = (kind?: ContentKind) => {
    if (kind && editing.value?.kind !== kind) return
    editing.value = null
    draft.value = null
  }

  const setDraft = (next: ContentDraft | null) => {
    if (next && editing.value?.kind !== next.kind) return
    draft.value = next
  }

  return { draft, editing, setDraft, startEditing, stopEditing, view }
}
